import * as requests from "../API/requests";

const makeInvestmentStore = {
  namespaced: true,

  state: () => ({
    plan: null,
    receipt: null,
  }),
  mutations: {
    setPlan(state, payload) {
      state.plan = payload;
    },
    setReceipt(state, payload) {
      state.receipt = payload;
    },
  },
  actions: {
    async getUserPlan(store) {
      const data = await requests.getPlanRequest();
      store.commit("setPlan", data);
      return data;
    },
    async generateReceipt(store, payload) {
      const data = await requests.generateReceiptRequest(payload);
      store.commit("setReceipt", data);
      return data;
    },
    async submitInvestmentDetails(_, payload) {
      return await requests.submitInvestmentDetailsRequest(payload);
    },
    async payWithCard(_, payload) {
      const data = await requests.paywithCardRequest({ ab: true, ...payload });
      return data.data;
    },
    async payWithMpesa(_, payload) {
      return await requests.paywithMpesaRequest(payload);
    },
    async makeTransaction(_, payload) {
      return await requests.makeTransactionRequest(payload);
    },
  },
  getters: {},
};
export default makeInvestmentStore;
